import { responsiveStyle } from '../responsive/responsive-style';
import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { style } from '../layer.css';

export const tabsList = style({
  display: 'flex',
  alignItems: 'flex-end',
  scrollbarWidth: 'none',
  overflowX: 'auto',
  boxShadow: `inset 0 -1px ${themeVars.color.border.tertiary}`,
});

export const tabsItem = style({
  cursor: 'pointer',
  border: 0,
  background: 'unset',
  color: themeVars.tab.foreground.default,
  position: 'relative',
  display: 'inline-flex',
  gap: space.s4,
  height: '100%',
  alignItems: 'center',
  flexShrink: 0,
  padding: `${space.s10}px ${space.s16}px`,

  ':hover': {
    color: themeVars.tab.foreground.hover,
  },

  ...responsiveStyle({
    mobile: {
      ...typography['labelMd'],
    },
    laptop: {
      ...typography['labelLg'],
    },
  }),

  selectors: {
    '&[data-state="active"]': {
      color: themeVars.tab.foreground.active,
    },
    '&[data-state="active"]::after': {
      content: '',
      height: '4px',
      width: '100%',
      backgroundColor: themeVars.tab.border.active,
      position: 'absolute',
      bottom: 1,
      left: 0,
      borderRadius: `${borderRadius.r8}px ${borderRadius.r8}px 0 0`,
    },
  },
});
export const tabsContent = style({
  selectors: {
    '&[data-state="active"]': {
      marginTop: space.s20,
    },
  },
});
